// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3DHHp","overflowing":"ReadFullNote_overflowing__3sJ3a"};